import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_EXTRAS: "SET_EXTRAS",
};

export default {
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },

  /**
   * Sets the extras [aggregations, comparisons and Operations ]
   */
  [types.SET_EXTRAS]: (state, { aggregations, comparisons, operations }) => {
    state.aggregations = aggregations;
    state.comparisons = comparisons;
    state.operations = operations;
  },
};
